import { ActionsLimit } from '@signageos/common-types/dist/Device/Actions/ActionLimit';
import { ITelemetryIntervals } from '../Device/Configuration/telemetryIntervals';

import { DeviceFeatureFlagRecord } from '../Device/Configuration/featureFlags';

export enum SubscriptionType {
	open = 'open',
	platform = 'platform',
}

interface IConfig {
	configUrls: string[];
	platformUri: string;
	staticBaseUrl: string;
	uploadBaseUrl: string;
	weinreUri: string;
	/**
	 * Platform specific remote control server url.
	 * For example, the samsung uses MagicInfo URL to connect to remote control server.
	 * @deprecated use UpdateExtendedManagementUrl action instead
	 */
	extendedManagementUrl: string | null;
	subscriptionType: SubscriptionType;
	checkInterval: number;
	telemetryIntervals?: ITelemetryIntervals | null;
	cacheInvalidationInterval?: number | null;
	checkTimeBeforeConnection?: boolean;
	offlineActionsLimits?: ActionsLimit | null;
	featureFlags?: DeviceFeatureFlagRecord | null;
	screenshotRotationPortrait?: number | null;
	telemetryInvalidatedAt?: string | null;
}
export default IConfig;
